export default __webpack_public_path__ + "static/mplatas-b47867801a3b599dd2752e1e9a0454f3.webp";